import React from "react";
import { CheckCircle2 } from "lucide-react";
import Button from "./Button";
import { CTA_URL, IMAGES, LANDING_COPY } from "../constants";

const Hero: React.FC = () => {
  const { hero } = LANDING_COPY;

  return (
    <>
      <a
        href="#reto"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 z-50 bg-primary text-white px-6 py-3 rounded-lg font-medium focus:outline-none focus-visible:ring-4 focus-visible:ring-white"
      >
        Saltar al contenido principal
      </a>

      <section
        id="inicio"
        className="relative min-h-screen flex items-center overflow-hidden pt-20"
        role="banner"
        aria-label="Introduccion al programa B2B IBEROTOURS"
      >
        <div className="absolute inset-0 z-0">
          <img
            src={IMAGES.hero}
            alt=""
            className="w-full h-full object-cover"
            aria-hidden="true"
            loading="eager"
            fetchPriority="high"
          />
          <div
            className="absolute inset-0 bg-gradient-to-br from-text-primary/95 via-primary/90 to-text-primary/92"
            aria-hidden="true"
          />
          <div className="absolute inset-0 bg-black/40" aria-hidden="true" />
          <div
            className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(232,200,7,0.1),_transparent_35%)]"
            aria-hidden="true"
          />
          <div
            className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,_rgba(217,24,48,0.06),_transparent_40%)]"
            aria-hidden="true"
          />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-20 md:py-28">
          <div className="max-w-4xl">
            <div className="mb-5 animate-fade-in-up">
              <span className="inline-flex items-center rounded-full bg-white/12 px-4 py-2 text-xs sm:text-sm font-semibold tracking-[0.1em] uppercase text-accent border border-white/20 backdrop-blur-sm">
                Programa B2B para agencias
              </span>
            </div>

            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-[3.5rem] text-white leading-[1.1] md:leading-[1.15] mb-8 font-display font-extrabold text-balance text-shadow-strong animate-fade-in-up animation-delay-100">
              {hero.headline}
            </h1>

            <p className="text-lg md:text-xl lg:text-2xl text-white/90 font-medium mb-10 max-w-3xl leading-relaxed text-balance animate-fade-in-up animation-delay-200">
              {hero.subheadline}
            </p>

            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10 max-w-3xl">
              {hero.bullets.map((bullet, index) => (
                <li
                  key={bullet}
                  className={`flex items-start gap-3 text-white/95 animate-fade-in-up`}
                  style={{ animationDelay: `${300 + index * 100}ms` }}
                >
                  <CheckCircle2
                    className="w-5 h-5 mt-0.5 text-accent flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span className="leading-relaxed">{bullet}</span>
                </li>
              ))}
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 items-start sm:items-center animate-fade-in-up animation-delay-700">
              <Button
                href={CTA_URL}
                size="lg"
                showArrow
                className="bg-accent hover:bg-accent-dark text-text-primary shadow-lg hover:shadow-xl btn-press"
              >
                {hero.cta}
              </Button>
            </div>
            <p className="text-sm text-white/80 mt-4 font-medium animate-fade-in-up animation-delay-800">
              {hero.microcopy}
            </p>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-fade-in animation-delay-700 hidden md:block">
          <a
            href="#reto"
            className="flex flex-col items-center text-white/60 hover:text-white/90 transition-colors"
            aria-label="Scroll hacia abajo"
          >
            <span className="text-xs uppercase tracking-widest mb-2">
              Explorar
            </span>
            <svg
              className="w-5 h-5 animate-bounce"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 14l-7 7m0 0l-7-7m7 7V3"
              />
            </svg>
          </a>
        </div>
      </section>
    </>
  );
};

export default Hero;
